// extracted by mini-css-extract-plugin
export default {"wrapper":"_a5093cba","header":"_7f59e256"};